export default __webpack_public_path__ + "static/media/1.b3fa195b.jpeg";